import { FontCategory } from '@quicktools/shared-components/data/fonts';

const props = {
  canonicalPath: 'text/font-generator/',
  headTitle: 'Font Generator - Fancy Text (𝒞𝑜𝓅𝓎 𝒶𝓃𝒹 𝒫𝒶𝓈𝓉𝑒)',
  headDescription:
    'The Picsart Font Generator tool can help you convert any text into fancy and eye-catching fonts in seconds, in just a few clicks.',
  heading: 'Font Generator',
  description:
    '#1 Font & Text Generator with 170+ fonts & 10 font styles (🅒🅞🅞🅛, 𝔣𝔞𝔫𝔠𝔶, 𝒸𝓊𝓇𝓈𝒾𝓋𝑒 and more).',
  shortDescription:
    '#1 Font & Text Generator with 170+ fonts & 10 font styles (🅒🅞🅞🅛, 𝔣𝔞𝔫𝔠𝔶 + more).',
  selectedCategory: FontCategory.All,
  inputPlaceholder: 'Add text here to get started…',
};

export default props;
